const BLOCK_SELECTOR = 'p, li, ol, ul, h1, h2, h3, h4, h5, h6, blockquote';

// Lets each paragraph pick its own direction from its text. Bilingual (MENA)
// stories mix English and Arabic paragraphs inside a container that may be
// dir="rtl", so paragraphs without an explicit direction would otherwise
// inherit the wrong one. Inline `direction` styles still take precedence.
export function withAutoTextDirection(html: string): string {
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  doc.body.querySelectorAll(BLOCK_SELECTOR).forEach((element) => {
    if (!element.hasAttribute('dir')) {
      element.setAttribute('dir', 'auto');
    }
  });
  return doc.body.innerHTML;
}

const ARABIC_CHAR = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/;
const LATIN_CHAR = /[A-Za-z\u00C0-\u024F]/;

// Direction of a piece of text from its first strong character, like dir="auto".
// Used where an element's own direction must be known up front (e.g. to position
// a block of English-led content inside a dir="rtl" container).
export function getTextDirection(text: string): 'ltr' | 'rtl' {
  for (const char of text.replace(/<[^>]*>/g, '')) {
    if (ARABIC_CHAR.test(char)) return 'rtl';
    if (LATIN_CHAR.test(char)) return 'ltr';
  }
  return 'ltr';
}
